import { Facebook, Twitter, Instagram, Linkedin, Mail } from 'lucide-react';

export const LandingFooter = () => {
  return (
    <footer className="bg-white border-t border-[#E5E7EB]">
      <div className="max-w-[1440px] mx-auto px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 mb-16">
          {/* Productos */}
          <div className="lg:col-span-2">
            <h4 className="mb-5">Productos</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Boletos de autobús
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Rutas populares
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Ofertas
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  App móvil
                </a>
              </li>
            </ul>
          </div>

          {/* Nosotros */}
          <div className="lg:col-span-2">
            <h4 className="mb-5">Nosotros</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Sobre Mexmo
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Carreras
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Prensa
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Recursos */}
          <div className="lg:col-span-2">
            <h4 className="mb-5">Recursos</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Centro de ayuda
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Contacto
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Términos de servicio
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Privacidad
                </a>
              </li>
            </ul>
          </div>

          {/* Extras */}
          <div className="lg:col-span-2">
            <h4 className="mb-5">Extras</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Programa de lealtad
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Afiliados
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  Socios
                </a>
              </li>
              <li>
                <a href="#" className="text-[#6B7280] hover:text-[#111827] text-sm transition-colors">
                  API
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="lg:col-span-4">
            <h4 className="mb-5">Newsletter</h4>
            <p className="text-[#6B7280] text-sm mb-4 leading-relaxed">
              Recibe ofertas exclusivas y noticias directamente en tu correo
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="tu@email.com"
                className="flex-1 px-4 py-3 border border-[#E5E7EB] rounded-[14px] focus:outline-none focus:ring-2 focus:ring-[#FF6A2A] focus:border-transparent text-sm transition-all"
              />
              <button className="bg-[#FF6A2A] hover:bg-[#C2410C] text-white px-5 py-3 rounded-[14px] transition-all">
                <Mail className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-10 border-t border-[#E5E7EB]">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Logo and Copyright */}
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-[#FF6A2A] rounded-[14px] flex items-center justify-center">
                  <span className="text-white font-bold text-lg">M</span>
                </div>
                <span className="text-xl font-semibold text-[#111827]">Mexmo</span>
              </div>
              <span className="text-[#6B7280] text-sm">
                © 2026 Mexmo. Todos los derechos reservados.
              </span>
            </div>

            {/* Social Icons */}
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-[#F7F8FA] rounded-[14px] flex items-center justify-center text-[#6B7280] hover:bg-[#FF6A2A] hover:text-white transition-all">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#F7F8FA] rounded-[14px] flex items-center justify-center text-[#6B7280] hover:bg-[#FF6A2A] hover:text-white transition-all">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#F7F8FA] rounded-[14px] flex items-center justify-center text-[#6B7280] hover:bg-[#FF6A2A] hover:text-white transition-all">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#F7F8FA] rounded-[14px] flex items-center justify-center text-[#6B7280] hover:bg-[#FF6A2A] hover:text-white transition-all">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};